// extracted by mini-css-extract-plugin
export var activityContainer = "_m8-0";
export var typingIndicatorContainer = "_m8-1";
export var typingIndicatorDot = "_m8-2";
export var wave = "_m8-3";